export const creditCards = [
  "Visa",
  "Mastercard",
  "American Express",
  "Discover",
  "Google Pay - Unknown",
  "Google Pay - Visa",
  "Google Pay - Mastercard",
  "Google Pay - Amex",
];
